export const SHARED_TOKEN_PREFIX = 'mp-share-';
export const SHARED_TOKEN_SUFIX = 'shared';
